import React from 'react';

export const useBadgeCount = (unreadCount: number) => {
  const [seenCount, setSeenCount] = React.useState(0);

  React.useEffect(() => {
    setSeenCount((seen) => (unreadCount < seen ? unreadCount : seen));
  }, [unreadCount]);

  const acknowledge = React.useCallback(() => setSeenCount(unreadCount), [unreadCount]);

  return {
    badgeCount: unreadCount > seenCount ? unreadCount : 0,
    acknowledge,
  };
};
